module.exports = {"logout":"Logout","login":"Login","register":"Register"}


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavAuthButtons/MobileNavAuthButtonsCopy.json
// module id = ./src/components/MobileNav/MobileNavAuthButtons/MobileNavAuthButtonsCopy.json
// module chunks = 4